// Why a press ended without a move and without a refused move (those are in the steps already), for the player's
// report steps (app-entry.tsx). Report 1407 (2026-10-26, Forty Thieves on a MacBook trackpad): "the card can be dragged
// but goes back", and the steps showed nothing, as a card that goes back before the rules see it left no trace.
type Listener = (why: string) => void;
const listeners = new Set<Listener>();

export function onDragBack(fn: Listener): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function dragBack(why: string): void {
  for (const fn of listeners) fn(why);
}
